export default {
  'billingSubscription.title': 'Subscriptions',
  'billingSubscription.description': 'Manage customer commercial subscriptions.',

  'billingSubscription.columns.billingLegalName': 'Legal name',
  'billingSubscription.columns.plan': 'Plan',
  'billingSubscription.columns.billingMode': 'Billing mode',
  'billingSubscription.columns.monthlyFee': 'Monthly fee',
  'billingSubscription.columns.currency': 'Currency',
  'billingSubscription.columns.billingCycleType': 'Billing cycle',
  'billingSubscription.columns.billingCycleCount': 'Cycle count',
  'billingSubscription.columns.paymentCollectionMode': 'Collection mode',
  'billingSubscription.columns.nextBillingDate': 'Next billing date',
  'billingSubscription.columns.autoRenew': 'Auto renew',

  'billingSubscription.fields.automyPlan': 'Automy plan',
  'billingSubscription.fields.customerChannelAssignment': 'Customer assignment',
  'billingSubscription.fields.defaultPaymentMethod': 'Default payment method',
  'billingSubscription.fields.paymentTermsDays': 'Payment terms (days)',
  'billingSubscription.fields.currentPeriodStart': 'Current period start',
  'billingSubscription.fields.currentPeriodEnd': 'Current period end',
  'billingSubscription.fields.billingLegalName': 'Legal name',
  'billingSubscription.fields.billingTaxId': 'Tax ID',
  'billingSubscription.fields.billingEmail': 'Billing email',
  'billingSubscription.fields.billingCountry': 'Billing country',
  'billingSubscription.fields.billingAddressLine1': 'Address line 1',
  'billingSubscription.fields.billingAddressLine2': 'Address line 2',
  'billingSubscription.fields.billingCity': 'City',
  'billingSubscription.fields.billingState': 'State / Province',
  'billingSubscription.fields.billingPostalCode': 'Postal code',
  'billingSubscription.fields.stripeCustomerId': 'Stripe customer ID',
  'billingSubscription.fields.stripeSubscriptionId': 'Stripe subscription ID',
  'billingSubscription.fields.stripePriceId': 'Stripe price ID',

  'billingPaymentMethodType.card': 'Card',
  'billingPaymentMethodType.bankAccount': 'Bank account',
  'billingPaymentMethodType.invoice': 'Invoice',

  'billingSubscriptionStatus.pendingActivation': 'Pending activation',
  'billingSubscriptionStatus.pendingPayment': 'Pending payment',
  'billingSubscriptionStatus.active': 'Active',
  'billingSubscriptionStatus.pastDue': 'Past due',
  'billingSubscriptionStatus.canceled': 'Canceled',
  'billingSubscriptionStatus.suspended': 'Suspended',

  'billingCycleType.monthly': 'Monthly',
  'billingCycleType.quarterly': 'Quarterly',
  'billingCycleType.annual': 'Annual',

  'billingCollectionMode.automatic': 'Automatic',
  'billingCollectionMode.manual': 'Manual',
};
